<!-- code ixA -->

<template lang="html">
  <div>
       <div class="ixAHead">
            <div class="head-name">{{className[classKey]}}</div>
            <div class="head-more" @click="itemSelect">
                 <span>更多</span>
                 <van-icon class="icon" class-prefix="iconfont" name="more" />
            </div>
       </div>

       <div class="ixClass">
            <div class="class-line">
                 <div v-for="(item,index) in filteritemsOne" :key="index" @click="classSeek(item)" class="class-item">
                      <span>{{item.text}}</span>
                 </div>
            </div>
            <div class="class-line" @click="classSeek">
                 <div v-for="(item,index) in filteredItems" :key="index"  @click="classSeek(item)" class="class-item">
                    <span>{{item.text}}</span>
                 </div>
            </div>
       </div>

       <AlbumList :listDat="songList" listType="2" iconType="1" class="album-list"/>
  </div>
</template>

<script>
import AlbumList from "@/components/AlbumList";
// import Songs from "./recSongs";
// import { getSongDets } from "@/api/song";
export default {
     props:['classDat','classKey','songList'],
     watch:{
         classDat:function(newDat){
             if(newDat.length > 0){
                  this.classArrs.splice(0,1,newDat);
             }
         },
     },
     components:{
          AlbumList
     },
     data(){
          return{
              classArrs:[[]],
              className:{1090:'中国戏曲',1093:'中国曲艺',1091:'民族歌曲',1094:'民间器乐',1092:'歌舞音乐'},
              publishList:[],

          }
     },
     created:function(){
          // let icds = Songs[this.classKey].icds;
          // let iabs = Songs[this.classKey].iabs;
     },
     computed: {
          filteritemsOne:function(){
               return this.classArrs[0].slice(0, 4);
          },
          filteredItems: function () {
               return this.classArrs[0].slice(4, 8);
          }
     },
     methods:{
          classSeek:function(item){
              this.push({
                  path:'seek',
                  query:{
                      classId:item.id,
                      classText:item.text,
                      postKey:'classifyList',
                      classType:1
                  }
              })
          },
          itemSelect:function(){
              let query = {
                 classId:this.classKey,
                 classText:'全部' + this.className[this.classKey],
                 postKey:'classifyList',
                 classType:1
              };

              this.push({
                   path:'seek',
                   query
              });
          },

     },
}
</script>

<style lang="css" scoped>

/* 头部 */

.ixAHead{
    padding-top: 10px;
    font-size: 16px;
    display: flex;
    align-items: center;
    margin: 0 10px;
    justify-content: space-between;
}

.ixAHead .head-name{
    font-weight: bold;
}

.head-more{
    display: flex;
    align-items: center;
}

.head-more span{
    font-size: 14px;
    color: #999999;
}

.head-more .icon{
    font-size: 25px;
    width: 16px;
    margin-left: -5px;
    color: #999999;
}

/* 分类 */

.class-line{
    margin: 0 10px;
    display: flex;
    font-size: 14px;
    margin-top: 15px;
    justify-content: space-between;
}

.class-item{
    width: 75px;
    height: 30px;
    overflow: hidden;
    background: #efefef;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.class-item span{
    font-size: 13px;
    color: #666666;
}

/* 列表 */

.album-list{
    margin-top: 9px;
}


</style>
